import FFLogo from '@forwardflow/assets/ff-onboarding-logo.svg'
import useAuthUser from '@forwardflow/hooks/customHooks/useAuthUser'
import { Stepper } from '@forwardflow/modules/onboarding'
import { Spinner } from '@forwardflow/ui'
import { Button, Group } from '@forwardflow/ui-v2'
import { Dropdown, MenuProps } from 'antd'
import { Power01Icon } from '@forwardflow/icons'
import { SelectUserOrganizationModal } from '@forwardflow/modals'
import OrganizationIcon from '@forwardflow/assets/svg/OrganizationIcon'
import { useSelectUserOrganizationModalStore } from '@forwardflow/store/modal/SelectUserOrganizationModal'
import {
   useOnboardingDataLoader,
   useLogout,
} from '@forwardflow/hooks/customHooks/onboarding'
import { SelectOperatorOrganization } from '@forwardflow/components'
import { isOperatorEmail } from '@forwardflow/utils/app.utils'
import { useOnboardingStoreV2 } from '@forwardflow/store'
// import { Link } from 'react-router-dom'

export const OnboardingLayout = ({
   children,
}: {
   children: React.ReactNode
}) => {
   const { data: user } = useAuthUser({
      revalidateOnMount: true,
   })
   const { onboardingData } = useOnboardingStoreV2()
   const { openSelectUserOrganizationModal } =
      useSelectUserOrganizationModalStore()

   // Extract all data loading logic to custom hook
   const { isLoading, currentOrganization } = useOnboardingDataLoader(
      user?.email
   )

   // Extract logout logic to custom hook
   const { logout } = useLogout()

   const items: MenuProps['items'] = [
      {
         label: (
            <button
               className="py-1 font-semibold text-[16px] flex items-center gap-2"
               onClick={logout}
            >
               <Power01Icon className="w-4 h-4" /> Logout
            </button>
         ),
         key: '0',
      },
   ]

   const currentOrganizationObj = user?.userOrganizations?.find(
      (org) => String(org.organizationId) === currentOrganization
   )

   return (
      <div className="relative bg-[#0A0A12] min-h-screen w-full">
         <div
            className="fixed inset-0 -translate-y-2 opacity-[0.05] pointer-events-none"
            style={{
               background:
                  'radial-gradient(50% 50% at 50% 50%, #A684FF 0%, rgba(166, 132, 255, 0.00) 100%)',
            }}
         />
         <div className="relative mx-auto min-h-screen py-12 px-5 pt-36 flex flex-col items-center justify-center">
            <div className="absolute top-10 left-10 w-[calc(100%-80px)] flex justify-between items-center z-10">
               <img
                  src={FFLogo}
                  alt="Forward Flow Logo"
                  className="w-16 h-16 mb-4"
               />
               <Group>
                  {isOperatorEmail(user?.email || '') && (
                     <SelectOperatorOrganization />
                  )}
                  {!isOperatorEmail(user?.email || '') &&
                     user?.userOrganizations?.length &&
                     user?.userOrganizations?.length > 1 && (
                        <>
                           <div
                              onClick={openSelectUserOrganizationModal}
                              className=" h-[50px] flex items-center bg-white bg-opacity-[0.04] hover:bg-opacity-[0.08] p-2 rounded text-sm w-56 cursor-pointer"
                           >
                              <span className="bg-[#27282C] rounded mr-6 flexc w-9 h-9">
                                 <span className="scale-95">
                                    <OrganizationIcon />
                                 </span>
                              </span>
                              <span>
                                 {currentOrganizationObj?.organization?.name ||
                                    'Organization'}
                              </span>
                           </div>
                           <SelectUserOrganizationModal />
                        </>
                     )}
                  <Dropdown menu={{ items }} trigger={['click']}>
                     <Button
                        variant="secondary"
                        className="w-16 h-16 rounded-full flex items-center justify-center text-lg font-semibold"
                     >
                        {user?.firstName
                           ? user?.firstName[0].toUpperCase()
                           : ''}
                     </Button>
                  </Dropdown>
               </Group>
            </div>
            {isLoading ? (
               <div className="flex items-center justify-center min-h-screen">
                  <Spinner />
               </div>
            ) : (
               <div
                  className="flex flex-col  mx-auto w-full"
                  style={{
                     maxWidth:
                        onboardingData.currentStep === 'dnd-stage-mapping'
                           ? 1400
                           : 864,
                  }}
               >
                  <div className="flex flex-col items-center justify-center gap-4 mb-8">
                     <h1 className="text-4xl font-bold">Forward Flow</h1>
                     <Stepper />
                  </div>

                  <div className="h-4"></div>
                  <div className="flex flex-col">{children}</div>
               </div>
            )}
            {/* {isOperatorEmail(user?.email || '') && (
               <Link
                  to="/dashboard"
                  className="mt-4 text-sm text-[#A684FF] hover:underline"
               >
                  Go to Dashboard
               </Link>
            )} */}
         </div>
      </div>
   )
}
